import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import InviteFriend from "./InviteFriends";
import { ToastContainer, toast } from "react-toastify";


const InviteTopline = () => {
  const [showModal, setShowModal] = useState(false);
  const [output, setOutput] = useState([]);
  const [selectedBox, setSelectedBox] = useState(null);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleOpenModal = (index) => {
    if (!isSubscribed) return;

    const isInvited = output[index];
    if (!isInvited) {
      setSelectedBox(index);
      setShowModal(true);
    }
  };

  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    const subscriptionStatus = sessionStorage.getItem("subscription_status");
    setIsSubscribed(subscriptionStatus === "yes");
  }, []);

  const user_key = sessionStorage.getItem("pk_user_key");

  const reverseString = (str) => (str ? str.split("").reverse().join("") : "");
  const reversedKey = reverseString(user_key);

  const getAllInvitedFriends = async () => {
    try {
      const response = await axios.post(BASE_URL + "API/apicall", {
        security_key: security_key,
        mode: "getAllInvitedFriends",
        invited_by: reversedKey,
      });
      setOutput(response.data || []);
    } catch (error) {
      console.error("Error fetching invited friends:", error);
    }
  };

  useEffect(() => {
    getAllInvitedFriends();
  }, []);

  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} />
      <div className="invite-tree mt-4">
        <div className="tree-line"></div>

        <div className="invite-section">
          {[...Array(12)].map((_, i) => {
            const friend = output[i];
            const isInvited = !!friend;

            return (
              <div
                key={i}
                className={`invite-card 
                  ${isInvited ? "invited" : ""} 
                  ${!isSubscribed ? "disabled" : ""}`}
                onClick={() => handleOpenModal(i)}
                style={{
                  cursor:
                    !isSubscribed || isInvited ? "not-allowed" : "pointer",
                  opacity: !isSubscribed ? 0.4 : isInvited ? 0.6 : 1,
                }}
              >
                {!isSubscribed ? (
                  <>
                    <small>Subscribe to invite</small>
                  </>
                ) : isInvited ? (
                  <>
                    <div>
                      <strong>
                        {friend.first_name} {friend.last_name}
                      </strong>
                    </div>
                    <small>is invited</small>
                  </>
                ) : (
                  <>
                    Click to
                    <br />
                    invite
                    <br />
                    friends
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Invite a Friend</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InviteFriend closeModal={handleCloseModal} />
        </Modal.Body>
      </Modal> */}

      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Invite a Friend</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InviteFriend closeModal={handleCloseModal} invitedList={output} getAllInvitedFriends={getAllInvitedFriends} />
        </Modal.Body>
      </Modal>

      <style jsx>{`
        .invite-tree {
          position: relative;
          padding-top: 40px;
          margin-top: 30px;
          overflow-x: auto;
        }

        .tree-line {
          position: absolute;
          top: 20px;
          left: 2%;
          right: 2%;
          height: 3px;
          background-color: #ccc;
          border-radius: 2px;
        }

        .invite-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: nowrap;
          gap: 15px;
          overflow-x: auto;
          padding: 20px 10px;
        }

        .invite-card {
          background-color: #b7d7a8;
          color: white;
          font-weight: 600;
          text-align: center;
          width: 110px;
          height: 90px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 6px;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          transition: transform 0.2s ease, background-color 0.2s ease;
          position: relative;
          flex-shrink: 0;
        }

        .invite-card::before {
          content: "";
          position: absolute;
          top: -20px;
          left: 50%;
          transform: translateX(-50%);
          width: 2px;
          height: 20px;
          background-color: #ccc;
        }

        .invite-card:hover {
          background-color: #9ccc65;
          transform: scale(1.05);
        }

        .invite-card.invited {
          background-color: #81c784;
          transform: none;
        }

        .invite-card.invited:hover {
          background-color: #81c784;
          transform: none;
        }

        /* ✅ disabled style for unsubscribed users */
        .invite-card.disabled {
          background-color: #bdbdbd !important;
          pointer-events: none;
          transform: none;
        }

        .invite-section::-webkit-scrollbar {
          height: 6px;
        }
        .invite-section::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 3px;
        }
      `}</style>
    </>
  );
};

export default InviteTopline;
